module.exports = __webpack_public_path__ + "img/logo.c33bef32.png";